var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseTemplate',{attrs:{"currentUser":_vm.currentUser}},[_c('div',{staticClass:"pay-redirect"})])
}
var staticRenderFns = []

export { render, staticRenderFns }